module.exports = __webpack_public_path__ + "img/touchpanel.34245671.webp";